<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    :overlay="false"
    width="50%"
  >
    <v-card>
      <!-- top bar START -->
      <v-toolbar
        dark
        color="secondary"
      >
        <v-btn
          icon
          dark
          @click.native="dialog = false; streams = {};singerDataTablesReady = false;$emit('close')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Settings for {{ integration.name }}</v-toolbar-title>
      </v-toolbar>
    </v-card>
  </v-dialog>
</template>
<script>
  import IntegrationService from './services/IntegrationService'
  import SingerService from './../Datastore/services/SingerService'
  export default {
    $_veeValidate: {
      validator: 'new',
    },
    props: {
      project: {
        type: Object,
        default: function () {
          return {
            name: '',
          }
        },
      },
    },
    data () {
      return {
        dialog: true,
        loading: false,
        integrations: [],
      }
    },
    computed: {
    },
    mounted () {
      this.getIntegrations()
    },
    methods: {
      getIntegrations () {
        var t = this
        t.loading = true
        IntegrationService.list(this, 0)
          .then(function (response) {
            if (response.data.results.length) {
              t.integrations = response.data.results
            }
          })
          .catch(function (error) {
            t.$store.commit('push', { msg: error, color: 'error' })
          })
          .finally(() => {
            t.loading = false
          })
      },
      close () {
        let self = this
        _.delay(() => {
          self.dialog = false
          self.$emit('close')
        })
      },
    },
  }
</script>
<style>
.integration-description {
  overflow: hidden;
  height: 40px;
  text-overflow: ellipsis;
}
.create-config-btn {
  position: absolute;
  top: 70px;
  right: 20px;
}
[role="table-sync"] .columns .dropdown > span > i {
  margin: -4px 2px;
}
[role="table-sync"] .columns .dropdown {
  text-align: center;
}
[role="table-sync"] .columns .dropdown > span {
  display: inline-block;
  margin: 7px 0px 0px;
  font-size: 13px;
  color: #c7c7c7;
}
[role="table-sync"] .columns [role="columns-table"] {
  margin-top: 15px;
  padding-top: 20px;
}
[role="table-sync"] [role="title"] {
  font-size: 20px;
}
[role="table-sync"] .sync {
  margin-top: -8px;
}
[role="table-sync"] .sync .v-btn__content {
  color: lightgray;
}
[role="table-sync"] .active.sync .v-btn__content {
  color: #1fcc95;
}
[role="table-sync"] .sync [role="icon"] {
  font-size: 17px;
  margin: 0 5px 0px 0px;
}
.scrollBody table tbody {
  display: block;
  max-height: 280px;
  overflow: auto;
}
.scrollBody table thead {
  text-align: left;
}
.scrollBody table thead,
.scrollBody table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.scrollBody table thead th:first-child {
  width: 50px;
}
.scrollBody table tbody tr td:first-child {
  width: 50px;
}
.config-name-field {
  padding: 10px 15px 0;
}
.global-checkbox {
  padding: 0 0 0 15px;
}
.global-tooltip {
  margin-top: -8px;
  margin-left: 5px;
}
.select-config {
  padding: 0 15px;
}
</style>
